/**
 * 값이 null 또는 undefined인지 확인합니다. (0과 구분할 필요가 있는 경우 사용)
 *
 * @param value 확인할 값
 * @returns 값이 null 또는 undefined인 경우 true를 반환하고, 그렇지 않은 경우 false를 반환합니다.
 */
function isNil<T>(value: T | null | undefined): value is null | undefined {
  return value === null || value === undefined;
}

export default isNil;
